



















import { LayoutModule } from "@/store/layout";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ClientCampaignsPerformanceSummary extends Vue {
  get loading(): boolean {
    return LayoutModule.loaderIsVisible;
  }

  details(): void {
    this.$router.push({
      name: "clientCampaignsPerformance",
    });
  }
}
